import { TQueries } from '@src/models/common';
import EventEmitter from 'events';

/** Точки прерывания.
 * MOBILE: 0,
 * TAB: 744,
 * DESKTOP: 1248,
 */
export const SCREEN_BREAKPOINTS = {
  MOBILE: 0,
  TAB: -1,
  DESKTOP: 745,
};

export const SORT_BREAKPOINTS = Object.entries<number>(SCREEN_BREAKPOINTS).sort((a, b) => b[1] - a[1]);

/** Значения для хука useMediaQueries
 * @see https://www.npmjs.com/package/@react-hook/media-query
 */
export const QUERIES = Object.keys(SCREEN_BREAKPOINTS).reduce((acc, key) => {
  acc[key] = `(min-width: ${SCREEN_BREAKPOINTS[key]}px)`;

  return acc;
}, {} as TQueries);

/**
 * Схема для url-ов, которые будут обрабатываться как команды страниц.
 * Например открыть модалку фидбека для демо или модалку фирдбека для заявки на конкретный продукт.
 *
 * По сути вопрос можно было решить как угодно иначе, но парсер URL уже есть в браузере
 * и он уже решает вопрос роутинга. Например ссылка из баннера может идти на конкретную страницу или баннер
 * например так /store/product/8 и тогда наш обработчик долэен просто сделать переход пользователя на эту страницу.
 * А например такой url centra://openFeedbackForm?formId=RequestPartner мы также сможем хранить в том же текстовом поле в БД
 * со ссылками с баннеров, но при этом обрабатывать его будем как заявку на открытие конкретной модалки.
 * Еще ожин пример centra://openFeedbackForm?formId=RequestConnect&productId=10
 *
 */
export const CENTRA_ROUTE_SCHEMA = 'centra://';

/** Общий класс для использования кастомных событий */
export const EVENT_EMITTER = new EventEmitter();
/** Объект с событиями */
export const EVENTS_NAME = {
  // Обработать внутренний роутинг. Подробнее читай в описании константы CENTRA_ROUTE_SCHEMA
  CENTRA_ROUTE_EVENT: 'CentraRouteEvent',

  //Записать данные о событии в Unit контексте
  UNIT_EVENT_LOG: 'UNIT_EVENT_LOG',

  /**
   * @deprecated Переделать в CA-1580
   * Открыть онбординг
   * @link https://centraai.atlassian.net/browse/CA-1580
   */
  OPEN_ON_BOARDING: 'OPEN_ON_BOARDING',

  /**
   * Изменение данных авторизации
   * @deprecated
   */
  AUTH: 'AuthEvent',
};

/**
 * Для названия события используем EVENTS_NAME,
 * Для ссылки внутреннего роута используем CENTRA_ROUTE_SCHEMA + CENTRA_EVENT_ROUTES
 * Т.е. CENTRA_EVENT_ROUTES указывает конкретно какое из внутренних событий необходимо обработать
 */
export const CENTRA_EVENT_ROUTES = {
  /** роут для событий открытия форм обратной связи */
  FEEDBACK: 'openFeedbackForm',
};
